<h2>{{ page_title }}</h2>
<p class="subtitle">¿No tienes credenciales? <a href="#">Contacta con nosotros</a></p>

@if (session_expired) {
  <p class="subtitle">Tu sesión ha caducado. Vuelve a iniciar sesión.</p>
}

<button mat-flat-button color="black" type="button" (click)="startLogin()" [disabled]="starting">
  {{ starting ? 'Redirigiendo...' : 'Iniciar sesión' }}
</button>
